import { FC, useState } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../Icons/Icon';
import styles from './CbAlertBanner.module.css';
export interface CbAlertBannerProps extends BoxProps {
  /*
    Optional. When omitted (or empty) the banner is always shown and cannot be
    dismissed — dismiss state is persisted in sessionStorage keyed by bannerId.
  */
  bannerId?: string;
  color?: string;
  dismissable: boolean;
}
export const CbAlertBanner: FC<CbAlertBannerProps> = ({
  bannerId,
  color = 'var(--chakra-colors-kirby-500)',
  dismissable,
  children
}) => {
  /*
    If we do not have a banner ID for this alert then we do not support dismiss behaviour.
    For that reason we default to showing the banner if the bannerID is null.
  */
  const [isShowing, setIsShowing] = useState(!bannerId || !sessionStorage.getItem(bannerId));
  const dismissAlert = bannerId => {
    sessionStorage.setItem(bannerId, 'dismissed');
    setIsShowing(false);
  };
  if (!isShowing) {
    return null;
  }
  return <Box backgroundColor={color} className={styles.banner} data-sentry-element="Box" data-sentry-component="CbAlertBanner" data-sentry-source-file="CbAlertBanner.tsx">
      <div className={styles.content}>
        <div className={styles.bannerChildren}>{children}</div>
        {!!bannerId && dismissable && <Button className={styles.closeButton} onClick={() => dismissAlert(bannerId)}>
            <ICON_BY_NAME.closecircle color="inherent" width="15px" height="15px" />
          </Button>}
      </div>
    </Box>;
};